/**
 * Continue Learning utility - manages localStorage for last viewed lesson
 */

const STORAGE_KEY = (userId) => `continueLearning:${userId || 'anon'}`;

/**
 * Save the last viewed lesson data
 * @param {string} userId - User ID or null for anonymous
 * @param {object} data - { lessonId, lessonTitle, subjectId, subjectName }
 */
export function saveContinueLearning(userId, data) {
  try {
    if (!data || !data.lessonId) return;
    const payload = {
      lessonId: data.lessonId,
      lessonTitle: data.lessonTitle || '',
      subjectId: data.subjectId || null,
      subjectName: data.subjectName || '',
      timestamp: Date.now()
    };
    localStorage.setItem(STORAGE_KEY(userId), JSON.stringify(payload));
  } catch (err) {
    console.error('Failed to save continue learning data:', err);
  }
}

/**
 * Load the last viewed lesson data
 * @param {string} userId - User ID or null for anonymous
 * @returns {object|null} - { lessonId, lessonTitle, subjectId, subjectName, timestamp } or null
 */
export function loadContinueLearning(userId) {
  try {
    const raw = localStorage.getItem(STORAGE_KEY(userId));
    if (!raw) return null;
    const data = JSON.parse(raw);
    // Validate essential field
    if (!data || !data.lessonId) return null;
    return data;
  } catch (err) {
    console.error('Failed to load continue learning data:', err);
    return null;
  }
}

/**
 * Clear the continue learning data
 * @param {string} userId - User ID or null for anonymous
 */
export function clearContinueLearning(userId) {
  try {
    localStorage.removeItem(STORAGE_KEY(userId));
  } catch (err) {
    console.error('Failed to clear continue learning data:', err);
  }
}
